import React from 'react';

import { ActionsheetWrapper } from 'components/action-sheet';

import { MenuReorderCard } from '../menu-reorder-card';
import { MenuReorderItemsList } from '../menu-reorder-items-list';

import { ActionsheetContentStyled } from './styled';
import { MenuReorderDetailsDrawerProps } from './types';

export const MenuReorderDetailsDrawer = ({
  showDrawer,
  toggleDetailsDrawer,
  order,
  openDetailEventMessage,
}: MenuReorderDetailsDrawerProps) => {
  return (
    <ActionsheetWrapper
      onOpenEventMessage={openDetailEventMessage}
      isOpen={showDrawer}
      onClose={toggleDetailsDrawer}
    >
      <ActionsheetContentStyled>
        <MenuReorderItemsList
          orderEntries={order.orderEntries}
          ListHeaderComponent={() => (
            <MenuReorderCard
              order={order}
              toggleDetailsDrawer={toggleDetailsDrawer}
              drawerIsOpen={showDrawer}
            />
          )}
        />
      </ActionsheetContentStyled>
    </ActionsheetWrapper>
  );
};
